// functions to add/edit/delete data from local/session storage

export const updateStorageUser = (newData, stayLoggedIn = false) => {
  try {
    let storage = stayLoggedIn ? localStorage : sessionStorage;
    let userData = JSON.parse(storage.getItem("user")) || {};
    userData.id = newData.id || userData?.id;
    userData.firstName = newData.firstName || userData?.firstName;
    userData.lastName = newData.lastName || userData?.lastName;
    userData.email = newData.email || userData?.email;
    userData.isAuthenticated =
      newData.isAuthenticated !== undefined
        ? newData.isAuthenticated
        : userData?.isAuthenticated;
    userData.isAdmin =
      newData.isAdmin !== undefined ? newData.isAdmin : userData?.isAdmin;
    userData.isOnline =
      newData.isOnline !== undefined ? newData.isOnline : userData?.isOnline;
    userData.stayLoggedIn =
      newData.stayLoggedIn !== undefined
        ? newData.stayLoggedIn
        : userData?.stayLoggedIn;
    if(newData.unreadMessages){
      userData.unreadMessages = newData.unreadMessages;
    }
    storage.setItem("user", JSON.stringify(userData));
  } catch (error) {
    console.log(error);
  }
};

export const updateStorageUnreadMessages = (data, stayLoggedIn = false) => {
  try {
    let storage = stayLoggedIn ? localStorage : sessionStorage;
    let userData = JSON.parse(storage.getItem("user")) || {};

    if(!userData.isAdmin){
      if(data.hasNewMessage) {
        userData.unreadMessages = {
          [data?.sessionId]: true
        }
      } else {
        userData.unreadMessages = {};
      }
    }
    else if (userData.isAdmin && userData.isOnline) {
      if (data.hasNewMessage) {
        userData.unreadMessages = {
          ...userData.unreadMessages,
          [data?.sessionId]: true,
        };
      } else {
        let updatedUnreadMessages = { ...userData.unreadMessages };
        delete updatedUnreadMessages[data?.sessionId];
        userData.unreadMessages = updatedUnreadMessages;
      }
    }
    storage.setItem("user", JSON.stringify(userData));
  } catch (error) {
    console.log(error);
  }
};

const emptyCart = { cartItems: {}, quantity: 0 };

export const addToStorageCart = (newItem, stayLoggedIn = false) => {
  //newProduct {productId: , count:}
  try {
    let storage = stayLoggedIn ? localStorage : sessionStorage;
    let { cartItems, quantity } =
      JSON.parse(storage.getItem("cart")) || emptyCart;
    const { productId, count } = newItem;
    if (cartItems[productId]) {
      cartItems[productId].count += count;
    } else {
      cartItems[productId] = { count: count };
    }
    quantity = quantity += count;
    storage.setItem("cart", JSON.stringify({ cartItems, quantity }));
  } catch (error) {
    console.log(error);
  }
};

export const deleteFromStorageCart = (productId, stayLoggedIn = false) => {
  try {
    let storage = stayLoggedIn ? localStorage : sessionStorage;
    let { cartItems, quantity } =
      JSON.parse(storage.getItem("cart")) || emptyCart;
    if (cartItems[productId]) {
      const count = cartItems[productId].count;
      delete cartItems[productId];
      quantity -= count;
      storage.setItem("cart", JSON.stringify({ cartItems, quantity }));
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateStorageCart = (itemToUpdate, stayLoggedIn = false) => {
  try {
    let storage = stayLoggedIn ? localStorage : sessionStorage;
    let { cartItems, quantity } =
      JSON.parse(storage.getItem("cart")) || emptyCart;
    const { productId, count } = itemToUpdate;
    if (cartItems[productId] && count >= 0) {
      const oldCount = cartItems[productId].count;
      cartItems[productId].count = count;
      if (count > oldCount) {
        quantity = quantity + (count - oldCount);
      } else {
        quantity = quantity - (oldCount - count);
      }
      storage.setItem("cart", JSON.stringify({ cartItems, quantity }));
    }
  } catch (error) {
    console.log(error);
  }
};

export const moveCartSessionToLocal = (stayLoggedIn) => {
  // if user just logged in and chose stayLoggedIn, and cart is in session storage,
  // move cart to local storage
  if (stayLoggedIn) {
    const sessionCart = JSON.parse(sessionStorage.getItem("cart"));
    if (sessionCart) {
      localStorage.setItem("cart", JSON.stringify(sessionCart));
      sessionStorage.removeItem("cart");
    }
  }
};

export const clearStorage = (storageItems, storage = null) => {
  //storageItems is array with names of storage items, eg "user", "token"
  try {
    storageItems.forEach((item) => {
      if (storage) {
        storage.removeItem(item);
      } else {
        localStorage.removeItem(item);
        sessionStorage.removeItem(item);
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const getStorageItem = (key, storage = null) => {
  //key is name of storage object, e.g. "user"
  let stringItem = "";
  try {
    if (storage) {
      stringItem = storage.getItem(key);
    } else {
      stringItem = localStorage.getItem(key);
      if (!stringItem) {
        stringItem = sessionStorage.getItem(key);
      }
    }
    let jsonItem = JSON.parse(stringItem);
    return jsonItem;
  } catch (error) {
    console.log("Error loading user from storage");
    return "";
  }
};

export const setStorageToken = (token, stayLoggedIn) => {
  try {
    let storage = stayLoggedIn ? localStorage : sessionStorage;
    storage.setItem("token", token);
  } catch (error) {
    console.log(error);
  }
};

export const getStorageToken = (stayLoggedIn) => {
  // arg: stayLoggedIn
  // return token from local/session storage
  try {
    let storage = stayLoggedIn ? localStorage : sessionStorage;
    return storage.getItem("token");
  } catch (error) {
    console.log(error);
  }
};
